import React from 'react'
import { component_tool } from '@/tool'
const { WizInput, WizRow, WizCol, WizComponent } = component_tool;

export default class QsInput extends WizComponent {

    render() {
        const { preview, answer } = this.props

        return (
            <WizRow>
                <WizCol>
                    { !preview ? answer : <WizInput /> }
                </WizCol>
            </WizRow>
        )
    }
}